import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { type ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { canActivate } from './utils/auth.guard';
import { DEFAULT_UNAUTHINTERCEPTOR, UnauthorizedInterceptor } from './utils/unauthorized.interceptor';
import { BASE_PATH } from './swagger';
import { RedirectorComponent } from './components/redirector/redirector.component';
import { AliasRedirectComponent } from './components/alias-redirect/alias-redirect.component';
import { UserPasswordComponent } from './pages/user/user-password/user-password.component';
import { ResetPasswordComponent } from './pages/user/reset-password/reset-password.component';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter([
      {
        path: 'anagrafiche',
        canActivate: [canActivate],
        data: {
          roles: ['Administrator']
        },
        loadChildren: () => import('./pages/anagrafiche/anagrafiche.module').then(m => m.AnagraficheModule)
      },
      {
        path: 'commesse',
        canActivate: [canActivate],
        data: {
          roles: ['JobManager']
        },
        loadChildren: () => import('./pages/jobs/jobs.module').then(m => m.JobsModule)
      },
      {
        path: 'statistiche',
        canActivate: [canActivate],
        data: {
          roles: ['JobManager']
        },
        loadChildren: () => import('./pages/statistiche/statistiche.module').then(m => m.StatisticheModule)
      },
      {
        path: 'operator',
        loadChildren: () => import('./pages/operator/operator.module').then(m => m.OperatorModule)
      },
      {
        path: 'o/:id',
        data: { url: '/operator/mobile/' },
        component: AliasRedirectComponent
      },
      {
        path: 'customer',
        canActivate: [canActivate],
        data: {
          roles: ['Customer']
        },
        loadChildren: () => import('./pages/customer/customer.module').then(m => m.CustomerModule)
      },
      {
        path: 'report',
        canActivate: [canActivate],
        data: {
          roles: ['UserAdmin']
        },
        loadChildren: () => import('./pages/report/report.module').then(m => m.ReportModule)
      },
      {
        path: 'pricelist',
        canActivate: [canActivate],
        data: {
          roles: ['PriceListManager', 'UserAdmin']
        },
        loadChildren: () => import('./pages/pricelist/pricelist.module').then(m => m.PricelistModule)
      },
      {
        path: 'password',
        canActivate: [canActivate],
        component: UserPasswordComponent
      },
      {
        path: 'password/:token',
        component: UserPasswordComponent
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent
      },
      {
        path: 'reset-password/:user',
        component: ResetPasswordComponent
      },
      {
        path: '',
        pathMatch: 'full',
        component: RedirectorComponent
      }
    ]),
    { provide: DEFAULT_UNAUTHINTERCEPTOR, useValue: false }, // questo serve per evitare che venga lanciato il 401
    provideHttpClient(withFetch(), withInterceptors([UnauthorizedInterceptor])),
    { provide: BASE_PATH, useValue: '' }
  ]
};
